import SplashMessage from 'components/SplashMessage';
import { isEqual } from 'lodash-es';
import React from 'react';
import FontAwesome from 'react-fontawesome';
import type { InvoiceQuery } from 'redux/modules/invoice.types';

interface Props {
  isLoading: boolean;
  query: InvoiceQuery;
  initialQuery: InvoiceQuery;
  isEmpty: boolean | null;
}

const InvoiceLandingPlaceholder: React.FC<Props> = ({
  isLoading,
  query,
  initialQuery,
  isEmpty,
}) => {
  const hasActiveQuery = !isEqual(initialQuery, query);

  const heading = () => {
    if (isLoading) {
      return 'Loading...';
    }
    return 'No invoices found';
  };

  const body = () => {
    if (isLoading) {
      return null;
    }
    if (hasActiveQuery && isEmpty != null && isEmpty) {
      return 'Expand your search by adjusting the filters.';
    }
    return 'You haven\'t created an invoice yet. Click the "New invoice" button to start.';
  };

  return (
    <SplashMessage style={{ paddingTop: 40 }}>
      <FontAwesome style={{ fontSize: 60, color: '#ccc', marginBottom: 15 }} name="file-invoice" />
      <h2 data-testid="no-invoice-found">{heading()}</h2>
      <p>{body()}</p>
    </SplashMessage>
  );
};

export default InvoiceLandingPlaceholder;
